import clsx from 'clsx';
import { ChangeEvent, createRef, KeyboardEvent, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TeamAddIcon } from '~components/icons';
import { useCreateUsergroup } from '~services/api/hooks/user-management.hooks';
import styles from './AddUsergroupForm.module.css';

export type AddUsergroupFormProps = {
  /* nothing yet */
};

export const AddUsergroupForm = (_props: AddUsergroupFormProps) => {
  const [nameInput, setNameInput] = useState('');
  const [hasError, setHasError] = useState(false);
  const refInput = createRef<HTMLInputElement>();

  // Define: create usergroup query
  const { mutate: createUsergroup, isPending: isUpdating } = useCreateUsergroup({
    onSuccess: () => {
      setNameInput('');
    },
    onError: () => {
      setHasError(true);
    },
  });

  // Handler: Input key press
  const handleOnKeyPress = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        setHasError(false);
        if (refInput.current) {
          refInput.current.blur();
        }
        if (nameInput && nameInput.length > 2) {
          createUsergroup({
            name: nameInput,
          });
        }
      }
    },
    [refInput, nameInput, createUsergroup],
  );

  // Hanlder: Input on change
  const handleOnChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setHasError(false);
    setNameInput(event.target.value);
  }, []);

  return (
    <div className={styles.container}>
      <label className={styles.label}>
        <span className={styles.labelIcon}>
          <TeamAddIcon />
        </span>
      </label>
      <div className={styles.positioner}>
        <div className={styles.inputWrapper}>
          <FormattedMessage id="placeholderAddUsergroup" defaultMessage="placeholderAddUsergroup">
            {(placeholder: any) => (
              <input
                value={nameInput}
                placeholder={placeholder}
                className={clsx(styles.input, hasError && styles.inputError)}
                onKeyPress={handleOnKeyPress}
                onChange={handleOnChange}
                ref={refInput}
                disabled={isUpdating}
              />
            )}
          </FormattedMessage>
        </div>
      </div>
    </div>
  );
};
